import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '产品丨古筝'
              }
            },
            {
              path: '/software/smartTown100',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown100'], resolve),
              meta: {
                title: '产品丨云杉100'
              }
            },
            {
              path: '/software/smartTown135',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown135'], resolve),
              meta: {
                title: '产品丨云杉135'
              }
            },
            {
              path: '/software/smartTown152',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown152'], resolve),
              meta: {
                title: '产品丨云杉152'
              }
            },
            {
              path: '/software/smartTown15201',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown15201'], resolve),
              meta: {
                title: '产品丨焦尾152'
              }
            },
            {
              path: '/software/smartTown15202',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown15202'], resolve),
              meta: {
                title: '产品丨流木152'
              }
            },
            {
              path: '/software/smartTownyz',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTownyz'], resolve),
              meta: {
                title: '产品丨龙吟'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '产品丨古筝周边'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js